import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const LOGIN_PATHS = {
  SUPER_ADMIN: "/ali-admin-portal/login",
  DOCTOR: "/doctor/login",
  RECEPTIONIST: "/staff/login",
};

export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-slate-50" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-teal-700" />
      </div>
    );
  }

  if (!user || user.role !== role) {
    return <Navigate to={LOGIN_PATHS[role]} replace />;
  }

  return children;
}
